/* eslint-disable react-hooks/rules-of-hooks */

import { create } from 'zustand';

import { useBreakpointValue } from '../../../../../../../design-system/hooks';
import { useLocalStorageState } from '../../../../../../../hooks/use-local-storage-state';

const store: any = create(() => ({
	isOpen: true,
	isContextOpen: true,
	isDetailsOpen: false,
}));

// This is a little tricky to acheive a smoot UX flow. We want people to be able to open
// the "details drawer", which shows in the "context drawer" but has an (x) button for closing.
// When the user closes that, if the drawer was closed before (context drawer state) then the
// drawer should close. If the drawer was open before, it should stay open, but because we have
// to open the "CONTEXT drawer" to show the "DETAILS drawer" we need to create separate disclosures
// and dance with them together, while also keeping track of the local-store-state.

// Then, because so many components need to work around it, I had to put it all into a store.

// THEN, because stores are so different, I wrapped it all in discosure-like API so it wasn't a PITA.

export const useDrawerDisclosure = () => {
	const bpv = useBreakpointValue({
		base: { isMobile: true },
		sm: { isMobile: false },
	});
	const isMobile = bpv?.isMobile;
	const [defaultOpenState, setDefaultOpenState] = useLocalStorageState('one-on-one-context-drawer-state', isMobile ? false : true);

	function getIsOpen() {
		return store.getState().isContextOpen || store.getState().isDetailsOpen;
	}

	if (!store.onOpenDetails) {
		store.setState({ isContextOpen: defaultOpenState });
		store.setState({ isOpen: getIsOpen() });

		Object.defineProperty(store, 'onOpenDetails', {
			value: () => {
				store.setState({ isDetailsOpen: true });
				store.setState({ isOpen: getIsOpen() });
			},
			writable: false,
			configurable: false,
			enumerable: false,
		});

		Object.defineProperty(store, 'onCloseDetails', {
			value: () => {
				store.setState({ isDetailsOpen: false });
				store.setState({ isOpen: getIsOpen() });
			},
			writable: false,
			configurable: false,
			enumerable: false,
		});

		Object.defineProperty(store, 'onOpen', {
			value: () => {
				store.setState({ isDetailsOpen: false });
				store.setState({ isContextOpen: true });
				store.setState({ isOpen: getIsOpen() });
				setDefaultOpenState(true);
			},
			writable: false,
			configurable: false,
			enumerable: false,
		});

		Object.defineProperty(store, 'onClose', {
			value: () => {
				store.setState({ isDetailsOpen: false });
				store.setState({ isContextOpen: false });
				store.setState({ isOpen: getIsOpen() });
				setDefaultOpenState(false);
			},
			writable: false,
			configurable: false,
			enumerable: false,
		});

		Object.defineProperty(store, 'isOpen', {
			get: () => store((state: any) => state.isOpen),
			set: (value: boolean) => {
				if (value) store.onOpen();
				else store.onClose();
			},
			configurable: false,
			enumerable: true,
		});
	}

	return store;
};
